import { useEffect } from 'react';
import { prop } from 'ramda';

import { useDeviceSelector } from 'js/store/hooks';

import style from './useDirectionalHover.scss';

const getDirection = (containerRef, coordinates) => {
    const w = containerRef.current.offsetWidth;
    const h = containerRef.current.offsetHeight;

    const rect = containerRef.current.getBoundingClientRect();
    const offset = {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX
    };

    const x = (coordinates.x - offset.left - w / 2) * (w > h ? h / w : 1);
    const y = (coordinates.y - offset.top - h / 2) * (h > w ? w / h : 1);

    return Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) % 4;
};

const getDirectionClass = (direction, isFrom) => {
    const directionClassFrom = [
        style.moveFromTop,
        style.moveFromRight,
        style.moveFromBottom,
        style.moveFromLeft
    ];
    const directionClassTo = [
        style.moveToTop,
        style.moveToRight,
        style.moveToBottom,
        style.moveToLeft
    ];

    return isFrom ? directionClassFrom[direction] : directionClassTo[direction];
};

export const useDirectionalHover = ({ containerRef, panelRef, className }) => {
    const isTouchDevice = useDeviceSelector(prop('isTouchDevice'));

    useEffect(() => {
        const refElement = containerRef.current;
        const panelElement = panelRef.current;

        if (!panelElement || isTouchDevice) {
            return;
        }

        const handleEvent = (event) => {
            const options = {
                speed: 300,
                easing: 'ease',
                hoverDelay: 0,
                inverse: false,
                checkMethod: null,
                className
            };

            const direction = getDirection(containerRef, { x: event.pageX, y: event.pageY });
            panelElement.style.animationDuration = `${options.speed}ms`;
            panelElement.style.animationEasing = options.easing;

            if (event.type === 'mouseenter') {
                panelElement.className = `${options.className} ${getDirectionClass(direction, true)}`;
                panelElement.style.display = 'block';
            } else {
                panelElement.className = `${options.className} ${getDirectionClass(direction, false)}`;
            }
        };

        refElement.addEventListener('mouseenter', handleEvent);
        refElement.addEventListener('mouseleave', handleEvent);

        return () => {
            refElement.removeEventListener('mouseenter', handleEvent);
            refElement.removeEventListener('mouseleave', handleEvent);
        };
    }, [containerRef, isTouchDevice, panelRef, className]);
};
